import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { CustomHostDirective } from 'gung-list';
import { first, Observable, of, Subject } from 'rxjs';
import { Availability } from '../../models/availability';
import { Product, ProductMultiDimension } from '../../models/product';
import { BaseViewConfigService } from '../../services/base-view-config/base-view-config.service';
import { ProductService } from '../../services/products/product.service';
import { CartRow } from '../../state/cart/types';
import { CustomerProductPrice } from '../../models/price';

@Component({
    selector: 'lib-buy-button-wrapper',
    templateUrl: './buy-button-wrapper.component.html',
    styleUrls: ['./buy-button-wrapper.component.css'],
    standalone: false
})
export class BuyButtonWrapperComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild(CustomHostDirective)
  viewChild: CustomHostDirective;

  @Input()
  id: string;

  @Input()
  product?: Product;

  @Input()
  price?: CustomerProductPrice;

  @Input()
  availability?: Availability;

  @Input()
  productPartialId?: string;

  @Input()
  minimumOrderQuantity?: number;

  @Input()
  stepAmount?: number;

  @Input()
  targetStockId?: string;

  @Input()
  disabled: boolean;

  @Input()
  disabledAdd: boolean;

  @Input()
  disabledSub: boolean;

  currentQty: number;
  previousQty: number;

  isOnlyDisplayFlow = false;
  unsubscribe: Subject<void> = new Subject();

  @Input()
  checkoutCart: CartRow | boolean;

  productTypeKey = 'productType';
  isMultiDimension = false;
  constructor(
    protected productService: ProductService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected componentFactoryResolver: ComponentFactoryResolver,
    protected baseViewConfigService: BaseViewConfigService
  ) { }

  ngOnInit(): void {
    let productObservable: Observable<Product>;
    if (!!this.product) {
      productObservable = of(this.product);
    } else {
      productObservable = this.productService.getProduct(this.id);
    }
    productObservable.subscribe(product => {
      this.product = product;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.product || changes.id || changes.productPartialId || changes.disabled) {
      let productObservable: Observable<Product>;
      if (!!this.product) {
        productObservable = of(this.product);
      } else {
        productObservable = this.productService.getProduct(this.id);
      }
      productObservable.pipe(first()).subscribe(product => {
        this.product = product;
      });

      if (this.viewChild) {
        // Clear views already rendered from previous navigation
        const containerRef = this.viewChild.viewContainerRef;
        containerRef.clear();
      }
      this.renderLayout(this.baseViewConfigService.getBuyButtonComponent(this.product, this.checkoutCart));
    }
  }

  ngAfterViewInit() {
    if (this.viewChild) {
      // Clear views already rendered from previous navigation
      const containerRef = this.viewChild.viewContainerRef;
      containerRef.clear();
    }
    this.renderLayout(this.baseViewConfigService.getBuyButtonComponent(this.product, this.checkoutCart));
  }

  renderLayout(viewComponent: any) {
    if (!this.viewChild) {
      return;
    }
    this.changeDetectorRef.detectChanges();
    const factory = this.componentFactoryResolver.resolveComponentFactory(viewComponent);
    const containerRef = this.viewChild.viewContainerRef;
    containerRef.clear();
    const componentRef = containerRef.createComponent(factory);
    const typedComponent = componentRef.instance as any;
    typedComponent.id = this.product?.id || this.id;
    if (!!this.productPartialId) {
      typedComponent.productPartialId = this.productPartialId;
    }
    if (!!this.targetStockId) {
      typedComponent.targetStockId = this.targetStockId;
    }
    typedComponent.product = this.product;
    typedComponent.price = this.price;
    typedComponent.disabled = this.disabled;
    if (!!this.availability) {
      typedComponent.availability = this.availability;
    }
    typedComponent.checkoutCart = this.checkoutCart;
    typedComponent.disabledAdd = this.disabledAdd;
    typedComponent.disabledSub = this.disabledSub;
    typedComponent.minimumOrderQuantity = this.minimumOrderQuantity;
    this.changeDetectorRef.detectChanges();
  }
}
